<template>
  <div class="welcome">
    <HeroSection theme="home/welcome">
      <div class="row justify-content-lg-between align-items-lg-center">
        <div class="col-lg-6 mb-7 mb-lg-0 pb-3">
          <!-- Info -->
          <h1 class="font-size-5 font-size-md-down-5 text-white font-weight-bold">
            Welcome to the <span class="text-warning">Cheap Mortgage Club</span>
          </h1>
          <vue-typed-js :showCursor="true" :loop="true" :strings="['a first time buyer.', 'moving house.', 'remortgaging.', 'a buy-to-let investor.']">
            <p class="text-white-70 h2">
              Helping you find the best mortgage deals if you're
              <span class="text-warning typing"></span>
            </p>
          </vue-typed-js>
          <br />
          <div class="sd-flex align-items-center flex-wrap">
            <router-link
                to="/products/remortgage"
                v-slot="{ href, route, navigate }">
              <button class="btn btn-light btn-block w-90" :href="href" @click="navigate">Find Remortgage Deals</button>
            </router-link>
          </div>
          <!-- End Info -->
        </div>

        <div class="col-lg-6 d-none d-lg-inline-block">
          <!-- SVG Icon -->
          <figure class="ie-knowledgebase-community-2">
            <img class="js-svg-injector w-90" src="/assets/cmc/svg/illustrations/knowledgebase-community-2.svg" alt="SVG Illustration"
                 data-parent="#SVGpricingHero">
          </figure>
          <!-- End SVG Icon -->
        </div>
      </div>
    </HeroSection>
  </div>
</template>

<style scoped>
  img.bottom-curve {
    margin-bottom: -5px;
    width: 100%;
  }
  
  .welcome.primary-hero {
    background-image: linear-gradient(-180deg,#006af0,#015acc);
  }
  .welcome.award-hero:before {
    content: "";
    padding: 80rem 30rem;
    position: absolute;
    background: #006af0;
    transform: rotate(70deg);
    top: -50%;
    left: 25%;
  }
</style>

<script>
import HeroSection from "@/components/layout/HeroSection";
export default {
  name: "Welcome",
  
  components: {
    HeroSection
  }
};
</script>
